<template>
  <div>
    <b-row class="mb-2">
      <b-col>
        <div class="float-right">
          <b-form-checkbox
            v-model="isRateLimit"
            :value="true"
            class="custom-control-success"
          > Es tarifa límite
          </b-form-checkbox>
        </div>
        <div>
          <!-- <pre>{{ room }}</pre> -->
          <strong>Tarifa inicial: </strong>
          <b-badge variant="warning" :class="room.detailSelected.priceMatchTax != ''? 'underline-price':''">
            {{ room.detailSelected.displayrates.CurrencyCode }} {{formatAmount(room.displayrates.priceInit)}}
          </b-badge>
        </div>
        <div v-if="room.detailSelected.PromotionName != ''">
          <strong>Promoción: </strong>{{room.detailSelected.PromotionName}}
        </div>

        <!-- <div v-if="room.showingRates">
          <strong>Tarifa manual:</strong> {{formatAmount(room.detailSelected.manualPrice)}}
        </div> -->
        <div v-if="!!precioToUse">
          <strong>Total: </strong> {{ room.detailSelected.displayrates.CurrencyCode }} {{precioToUse }}
        </div>
      </b-col>
    </b-row>
    <b-row align-v="end">
      <b-col md="">
        <div v-if="!isLoadingRates">
          <div class="mb-half">Tarifa ({{currency.code}})</div>
          <b-form-input
            placeholder="Tarifa"
            type="text"
            @keypress="onlyNumber"
            @change="setManualPrice"
            v-model="room.detailSelected.displayrates.manualPrice"
          />
        </div>
        <div class="text-center" v-if="isLoadingRates">
            <b-spinner label="Loading..." variant="success"/><br>
            <strong>Buscando tarifa</strong>
        </div>
      </b-col>

      <b-col md="4" class="text-right">
        <b-button
          variant="primary"
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          :disabled="room.detailSelected.displayrates.manualPrice == '' || !room.showingRates || isLoadingRates"
          @click="checkPriceMatchByManualRate"
          title="Buscar por tarifa manual"
          ><feather-icon icon="SearchIcon"/>
        </b-button>
          <!-- v-b-tooltip.hover.left="'Buscar por tarifa manual'" -->
      </b-col>
    </b-row>
    <div v-if="!isLoadingRates">
      <div 
        v-if="room.detailSelected.PromotionName != '' && isRateLimit "
        class="d-flex justify-content-between align-items-center mt-2 "
      >
        <div>
          <ValidationProvider name="Comprobante para autorización">
              <b-form-group label="Comprobante para autorización (opcional)" slot-scope="{ valid, errors }">
                <b-form-file
                  v-model="file"
                  @input="setImgFile(file)"
                  placeholder="Adjunte una o más imagenes como evidencia..."
                  drop-placeholder="Drop file here..."
                  :state="errors[0] ? false : (valid ? true : null)"
                  browse-text="Buscar imagen"
                  :disabled="isAuthorizingRate"
                  multiple
                />
                <b-form-invalid-feedback>{{ errors[0] ? 'Se debe adjuntar la evidencia para la autorización' : '' }} </b-form-invalid-feedback>
              </b-form-group>
          </ValidationProvider>
          <b-card-text class="my-1">
            {{fileMessage}} <strong v-for="f in file" :key="f.name">{{ f ? f.name : '' }},&nbsp;</strong>
          </b-card-text>
        </div>
        <b-button          
          variant="primary"
          @click="addToCartOrAuthorize"
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          v-b-tooltip.hover.top="'Autorizar tarifa manual'"
        > 
          <div v-if="file && file.length > 0">
            <feather-icon icon="UnlockIcon"/>
            Autorizar
          </div>
          <div v-else>
            <feather-icon
              icon="ShoppingCartIcon"
              size="16"
            /> Añadir
          </div>
        </b-button>
      </div>
      <div 
        v-if="room.detailSelected.PromotionName != '' && !isRateLimit "
        class="d-flex justify-content-end align-items-center mt-2"
      >
        <b-button          
          variant="primary"
          @click="addToCartOrAuthorize"
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          v-b-tooltip.hover.top="'Tarifa límite'"
        > <feather-icon icon="UnlockIcon"/> Autorizar</b-button>
      </div>
    </div>
    <AuthorizeBooking
      :room="room"
      @set-payload-add-to-cart="handlerAddToCart"
    />
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { toJson, currentDate, globalCurrencyFormat, showAlertMessage, filterFilesByType, filterFilesBySize, filterFilesByName } from '@/helpers/helpers'
import { VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import AuthorizeBooking from '@/modules/shop/components/bookings/AuthorizeBooking'

export default {
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props:{
    room:{
      type: Object,
      required: true,
    },
    isLoadingRates:{
      type: Boolean,
      required: true,
    }
  },
  components: {
    AuthorizeBooking
  },
  data() {
		return {
      isRateLimit: false,
      file: null,    
      isAuthorizingRate: false
		}
	},
  computed:{
		...mapState('shop',['currency']),
		...mapState('start',['currencies']),
    ...mapState('bookings',['searchForms','userAuthorizeRate']),
    ...mapState('auth',['user']),
    precioToUse(){
      const precioToUse = (this.room.detailSelected.displayrates.priceMatchTax != '' ) ? this.room.detailSelected.displayrates.priceMatchTax : this.room.detailSelected.displayrates.AmountAfterTax
      return globalCurrencyFormat(precioToUse || 0.00)
    },
    exchangeRate(){
      return (Math.round( (this.room.detailSelected.divisa.value) * 100) / 100).toFixed(2)
    },
    fileMessage(){
      return !this.file?.length ? '' : this.file?.length > 1 ? 'Imagenes seleccionadas:' : 'Imagen seleccionada:'
    }
  },
  methods:{    
    ...mapActions('bookings',['authorizeRateUser']),
    ...mapMutations('bookings',['setManualPriceSelectedRate','setUserAuthorizationUrl']),
    setManualPrice(){
     const keyRoom = this.room.keyRoom
     const manualRate = this.room.detailSelected.manualPrice
     const payload = { keyRoom, manualRate }
     this.setManualPriceSelectedRate(payload)
    },
    setImgFile(file){
      if(file) this.file = file
      else {
        const text = `😪😪 Tiene que adjuntar un archivo de tipo imagen`
        showAlertMessage( 'No hay imagen', 'InfoIcon', text, 'danger', 4000, 'bottom-right')
      }
    },
    onlyNumber(event){
			let keyCode = (event.keyCode ? event.keyCode : event.which)
			if ((keyCode < 48 || keyCode > 57) ) { // 46 is dot
				event.preventDefault()
			}
		},
    checkPriceMatchByManualRate(){
      const searchForm = toJson(this.searchForms.find( item => item.fromTab === this.room.fromTab ))
      const { hotel, idioma, dateIn, dateOut, ninos, adults, children, vendorcode } = searchForm
      const { RoomTypeCode, keyRoom, priceInit } = this.room
      const manualRateFormat = parseFloat( this.room.detailSelected.displayrates.manualPrice )
      const priceInitFormat = parseFloat( priceInit )
      const requiresRecalc = this.room.detailSelected.CurrencyCode != this.currency.code

        this.room.detailSelected.allowPriceMatch = true  //muestro tab para price match manual rate
        const payload = {
          adults,
          children,
          dateIn,
          dateOut,
          hotel,
          idioma,
          isManualRate: true,
          keyRoom, //lo ocupo de manera interna
				  manualRate: manualRateFormat, //requirido para price match manual price
          ninos,
          priceInit, //lo ocupo de manera interna
          promotionCode: '', //vacío
          rate: priceInitFormat, //requirido para price match manual price
          rateplanid: "",
          roomCode: RoomTypeCode,
          tarifa: this.room.detailSelected.RatePlanCode,
          vendorcode,
          requiresRecalc
        }

      this.$emit('check-price-match-by-promotion-code', payload )
    },
    async addToCartOrAuthorize(){   
      if( !this.isRateLimit ) {
        this.openModal()
      }
      if( this.isRateLimit ) {
        const payload = {
          authorizationUser: null,
          dateAuthorization: null,
          isAuthorization: false,
          isRateLimit: true,
          requiresAuthorization: false,
          urlAuthorization: null,
        }
        if (this.file && this.file.length > 0) {   

          const validFiles = this.validateFiles()
          if (!validFiles) return  

          const payloadAutorize = { user: this.user.idUser, code: null, username: this.user.username, file: this.file, isPriceMatch: false }
          this.isAuthorizingRate = true
          const url = await this.authorizeRateUser(payloadAutorize) 
          this.isAuthorizingRate = false
          if( url ){
            this.setUserAuthorizationUrl(url)
          }
          payload.authorizationUser = this.user.idUser
          payload.dateAuthorization = currentDate()
          payload.isAuthorization = true 
          payload.urlAuthorization = url
        }
        this.file = null
        this.$emit('handler-add-to-cart', payload)        
      }
    },
    // handlerAddCart(){   
    //   this.openModal()
    // },
    handlerAddToCart(){
      const { idUser, urlAuthorization } = this.userAuthorizeRate
      this.closeModal()
      const payload = {
        authorizationUser: idUser,
        dateAuthorization: currentDate(),
        isAuthorization: true,
        isRateLimit: false,
        requiresAuthorization: false,
        urlAuthorization
      }
      this.$emit('handler-add-to-cart', payload)
    },
        
    openModal(){
			this.$root.$emit('bv::show::modal', 'authorize-rate'+this.room.keyRoom)
    },
    closeModal(){
			this.$root.$emit('bv::hide::modal', 'authorize-rate'+this.room.keyRoom)
    },
    formatAmount(amount){
      return globalCurrencyFormat(amount)
    },
    validateFiles(){
      if (this.file.length > 5) {
        this.file = null
        showAlertMessage( 'Maximo alcanzado', 'InfoIcon', 'No puedes subir más de 5 archivos', 'warning', 4000, 'bottom-right')
        return false
      }

      const filteredByType = filterFilesByType(this.file)
      if (!filteredByType) return false

      const filteredBySize = filterFilesBySize(filteredByType, 2202009.6)
      if (!filteredBySize) return false

      const filteredByName = filterFilesByName(filteredBySize)
      if (!filteredByName) return false

      return true
    },
  }
}
</script>

<style>
.custom-margin-price-match{
  margin: 0.3rem !important;
}
</style>
